// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__M+4W0","spinner-animation":"Spinner_spinner-animation__4Jxql"};